import { FooterAnalyticsEnum } from './footer/footer-analytics.enum';
import { HomeAnalyticsEnum } from './home/home-analytics.enum';
import { BlogAnalyticsEnum } from './blog/blog-analytics.enum';
import { GenericAnalyticsEnum } from './generic/generic-analytics.enum';
import { BranchAnalyticsEnum } from './entities/branch-analytics.enum';
import { PartnerAnalyticsEnum } from './entities/partner-analytics.enum';
import { ProfessionalsAnalyticsEnum } from './entities/professionals-analytics.enum';
import { SpecialtyAnalyticsEnum } from './entities/speciality-analytics.enum';
import { LaboratoryAnalyticsEnum } from './entities/laboratory-analytics.enum';
import { ExamAnalyticsEnum } from './entities/exam-analytics.enum';
import { CityAnalyticsEnum } from './entities/city-analytics.enum';
import { LocationAnalyticsEnum } from './location/location-analytics.enum';
import { BranchCardAnalyticsEnum } from './entities/branch-card.analytics.enum';

export const AnalyticsEnum = {
  ...HomeAnalyticsEnum,
  ...FooterAnalyticsEnum,
  ...BlogAnalyticsEnum,
  ...GenericAnalyticsEnum,
  ...BranchAnalyticsEnum,
  ...BranchCardAnalyticsEnum,
  ...PartnerAnalyticsEnum,
  ...ProfessionalsAnalyticsEnum,
  ...SpecialtyAnalyticsEnum,
  ...LaboratoryAnalyticsEnum,
  ...ExamAnalyticsEnum,
  ...CityAnalyticsEnum,
  ...LocationAnalyticsEnum,
} as const;

export type AnalyticsEnumKeyType = (typeof AnalyticsEnum)[keyof typeof AnalyticsEnum];
